<app-auth-page-layout>
  <div class="flex flex-col flex-1">
    <div class="flex flex-col justify-center flex-1 w-full max-w-lg mx-auto">

      <div class="mb-5 sm:mb-8 text-center">
        <h1 class="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
          Setup Two-Factor Authentication
        </h1>
        <p class="text-sm text-gray-600 dark:text-gray-400">
          Protect your account by setting up a second verification step. Choose the method that works best for you and complete setup to continue.
        </p>
      </div>

      <app-two-factor-setup
        [forceSetupRequired]="true"
        [redirectToLoginAfterSuccess]="true"
        [setupTokenInput]="setupToken"
        [identifierInput]="setupIdentifier"></app-two-factor-setup>

      <div class="mt-4 flex justify-center">
        <button type="button" (click)="cancelToLogin()"
          class="inline-flex items-center justify-center gap-2 text-sm leading-none text-brand-500 hover:text-brand-600 dark:text-brand-400">
          <i class="bi bi-arrow-left self-center text-base"></i>
          <span class="self-center leading-none">Back to Login</span>
        </button>
      </div>
    </div>
  </div>
</app-auth-page-layout>